import React from 'react'
// components
import RiskAPI from 'containers/Risks/Risk/Edit/layers/API'
import PublicRiskEdit from 'components/PageComponents/Risks/PublicEdit'
import RiskTemplateAPI from 'containers/Risks/RiskTemplate/Edit/layers/API'
import RiskTransactions from 'containers/Risks/Risk/Edit/layers/RiskTransactions'

export const PublicContext = React.createContext(false)

const PublicRiskEditContainer = () => (
  <PublicContext.Provider value={true}>
    <RiskAPI>
      <RiskTemplateAPI>
        <RiskTransactions>
          <PublicRiskEdit />
        </RiskTransactions>
      </RiskTemplateAPI>
    </RiskAPI>
  </PublicContext.Provider>
)

export default PublicRiskEditContainer
